
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { useAnalytics } from "@/hooks/use-analytics";

const FeedbackSection = () => {
  const { t } = useTranslation();
  const { trackProfileAction } = useAnalytics();

  const openFeedbackForm = () => {
    window.open("https://forms.office.com/Pages/ResponsePage.aspx?id=wvf0s85ykkGrpNbHcZtXZiTSd14A_u5NkYT6W7-McpVUMElCUzdGN1hSTVdKM0dFV1M0MEU5NzU3VS4u", "_blank");
    trackProfileAction('view_profile', 'success', 'feedback_form_click');
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">
        {t("settings.feedback.title", "Feedback")}
      </h3>
      <p className="text-sm text-muted-foreground">
        {t("settings.feedback.description", "We value your feedback. Help us improve our service by sharing your thoughts.")}
      </p>
      <Button 
        onClick={openFeedbackForm} 
        className="w-full flex items-center justify-center gap-2 bg-[#000835] hover:bg-[#00052a]"
      >
        <MessageCircle className="w-5 h-5" />
        <span>{t("settings.feedback.button", "Give Feedback")}</span>
      </Button>
    </div>
  );
};

export default FeedbackSection;
